<template>
    <div>
        <table border=1 v-if="days.length > 0">
            <tr>
                <th colspan="2">取材人数 (Min)</th>
                <td v-for="d in days" :key="d.key">
                    <input min=0 max=99 type="number" :value="d.minReporter" @change="setMinReporter(d, $event.target.value)">
                </td>
            </tr>
            <tr>
                <th colspan="2">取材人数 (Max)</th>
                <td v-for="d in days" :key="d.key">
                    <input min=0 max=99 type="number" :value="d.maxReporter" @change="setMaxReporter(d, $event.target.value)">
                </td>
            </tr>
            <tr>
                <th colspan="2">編集人数 (Min)</th>
                <td v-for="d in days" :key="d.key">
                    <input min=0 max=99 type="number" :value="d.minEditor" @change="setMinEditor(d, $event.target.value)">
                </td>
            </tr>
            <tr>
                <th>メンバー</th>
                <th>休み日数</th>
                <th v-for="d in days" :key="d.key">
                    <span :class="`weekday weekday-${d.weekday}`">{{ ['日', '月', '火', '水', '木', '金', '土'][d.weekday] }}</span>
                    <br>{{ d.month }}/{{ d.day }}
                    <br><input class="note" :value="d.note" size="4" placeholder="メモ" @change="setNote(d, $event.target.value)">
                </th>
            </tr>
            <tr v-for="p in people" :key="p.key">
                <td>
                    <input :value="p.name" size="6" @change="updatePerson(p, {name: $event.target.value})">
                    <button @click="removePerson(p)">削除</button>
                    <br>
                    <label><input id="can_report" type="checkbox" :checked="p.isReporter" @change="updatePerson(p, {isReporter: $event.target.checked})">取材</label>
                    <label><input id="can_edit" type="checkbox" :checked="p.isEditor" @change="updatePerson(p, {isEditor: $event.target.checked})">組み</label>
                </td>
                <td :class="(editMode == 'assigned' && p.absentTarget != p.sumAbsent) ? 'error' : ''">
                    <span v-if="editMode == 'assigned'">
                    {{ p.sumAbsent }} /
                    </span>
                    <input :value="p.absentTarget" type="number" min="0" max="99" @change="setAbsentTarget(p, $event.target.value)">
                </td>
                <td :class="`daycell ${editMode} ${(editMode == 'preferred') ? pp.preferred : pp.assigned}`"
                    v-for="pp in getAttendanceVector(p)" :key="pp.dayKey">
                    <div v-if="editMode == 'preferred'">
                        <label><input type="radio" :checked="pp.preferred == null" @change="setPreferredState(p.key, pp.dayKey, null)">なし</label><br>
                        <label><input type="radio" :checked="pp.preferred == 'A'" @change="setPreferredState(p.key, pp.dayKey, 'A')">★休</label><br>
                        <label><input type="radio" :checked="pp.preferred == 'W'" @change="setPreferredState(p.key, pp.dayKey, 'W')">★出</label><br>
                    </div>
                    <div v-if="editMode == 'assigned'">
                        <div @click="setAssignedState(p.key, pp.dayKey, pp.assigned ? null: 'a')">
                            <div :class="`preferred-ref ${pp.preferred}`">
                                {{ {'A': '休み希望', 'W': '出勤希望', null: '-'}[pp.preferred] }}
                            </div>
                            <div class="label">{{ pp.assigned ? '休み' : '出勤' }}</div>
                        </div>
                    </div>
                </td>
                <td></td>
            </tr>
            <tr v-if="editMode == 'preferred'">
                <th colspan=2>休み希望（取材）</th>
                <td></td>
                <td v-for="d in days" :key="d.key">
                    {{ d.sumRequiredAbsence.reporter }}
                </td>
            </tr>
            <tr v-if="editMode == 'preferred'">
                <th colspan=2>休み希望（組み）</th>
                <td></td>
                <td v-for="d in days" :key="d.key">
                    {{ d.sumRequiredAbsence.editor }}
                </td>
            </tr>
            <tr v-if="editMode == 'preferred'">
                <th colspan=2>休み希望（全体）</th>
                <td></td>
                <td v-for="d in days" :key="d.key">
                    {{ d.sumRequiredAbsence.total }}
                </td>
            </tr>
            <tr v-if="editMode == 'assigned'">
                <th colspan=2>実際の取材人数</th>
                <td v-for="d in days" :key="d.key"
                    :class="d.sumPeople.reporter - d.sumAssignedAbsence.reporter - d.minReporter < 0 ? 'error' : ''">
                    <strong>{{ d.sumPeople.reporter - d.sumAssignedAbsence.reporter }}</strong> ≧ {{ d.minReporter }}
                    </span>
                </td>
            </tr>
            <tr v-if="editMode == 'assigned'">
                <th colspan=2>実際の編集人数</th>
                <td v-for="d in days" :key="d.key">
                    <span :class="d.sumPeople.editor - d.sumAssignedAbsence.editor - d.minEditor < 0 ? 'error' : ''">
                    <strong>{{ d.sumPeople.editor - d.sumAssignedAbsence.editor }}</strong> ≧ {{ d.minEditor }}
                    </span>
                </td>
            </tr>
        </table>
        <p>
            <button v-if="editMode == 'assigned'" @click="solve()">自動最適化</button>
            <button @click="addPerson()">メンバー追加</button></p>
        </p>
    </div>
</template>


<script>
import Firebase from 'firebase';
import { solve } from './solver';

export default {
    methods: {
        solve() {
            let result = solve(this.people, this.days);
            let updates = {};
            for (let dayKey in result) {
                updates[`days/${dayKey}/assigned`] = result[dayKey];
            }
            Firebase.database().ref('/').update(updates);
        },
        addPerson() {
            Firebase.database().ref('people').push({
                name: "New Person",
                absentTarget: 10,
                isReporter: true,
                isEditor: false,
                preferred: {},
                assigned: {},
            });
        },
        getAttendanceVector(person) {
            return this.days.map((d) => {
                return {
                    dayKey: d.key,
                    preferred: (d.preferred && d.preferred[person.key]) || null,
                    assigned: (d.assigned && d.assigned[person.key]) || null,
                };
            })
        },
        setAssignedState(personKey, dayKey, state) {
            Firebase.database().ref(`/days/${dayKey}/assigned/${personKey}`).set(state);
        },
        setPreferredState(personKey, dayKey, state) {
            Firebase.database().ref(`/days/${dayKey}/preferred/${personKey}`).set(state);
        },
        updatePerson(person, values) {
            Firebase.database().ref(`/people/${person.key}`).update(values);
        },
        removePerson(person) {
            if (confirm(`${person.name}さんを削除してよろしいですか？`)) {
                Firebase.database().ref(`/people/${person.key}`).remove();
            }
        },
        setAbsentTarget(person, value) {
            let v = Math.floor(value);
            Firebase.database().ref(`/people/${person.key}/absentTarget`).set(v);
        },
        setNote(day, value) {
            Firebase.database().ref(`/days/${day.key}/note`).set(value);
        },
        setMinReporter(day, value) {
            let v = Math.floor(value);
            Firebase.database().ref(`/days/${day.key}/minReporter`).set(v);
        },
        setMaxReporter(day, value) {
            let v = Math.floor(value);
            Firebase.database().ref(`/days/${day.key}/maxReporter`).set(v);
        },
        setMinEditor(day, value) {
            let v = Math.floor(value);
            Firebase.database().ref(`/days/${day.key}/minEditor`).set(v);
        },
    },
    props: ['people', 'days', 'editMode'],
    components: {
    }
}
</script>


<style lang="scss" scoped>
table {
    table-layout: fixed;
    border-collapse: collapse;
    font-size: 14px;
    white-space: nowrap;
    .error {
        background-color: #c00;
        color: white;
        input {
            background-color: rgba(255, 255, 255, 0.5);
            color: white;
        }
    }
    .note {
        color: #f70;
        font-weight: bold;
    }
}
td, th {
    border: 2px solid white;
}
.weekday {
    &.weekday-0 { color: red; }
    &.weekday-6 { color: blue; }
}
.daycell {
    font-size: 13px;
    background-color: #ddd;
    width: 6em;
    &.A {
        color: white;
        background-color: #ff5555;
    }
    &.W {
        color: white;
        background-color: #4466ff;
    }
}
.daycell.assigned {
    margin: 3px 0 0;
    border-radius: 3px;
    text-align: center;
    cursor: pointer;
    color: white;
    background-color: #ff5555;
    user-select: none;
    -webkit-user-select: none;
    & > div {
        width: auto;
        min-width: 46px;
        overflow: hidden;
    }
    .label {
        margin: 0.3em 0;
        user-select: no;
    }
    &.null {
        color: white;
        background-color: #4466ff;
    }
    .preferred-ref {
        margin: 4px 0 4px;
        padding: 3px;
        line-height: 1;
        text-align: center;
        font-size: 10px;
        background-color: #aaa;
        &.A {
            color: white;
            background-color: #ff5555;
        }
        &.W {
            color: white;
            background-color: #4466ff;
        }
        &.null {
            color: white;
            background-color: transparent;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/Matrix.vue